export default __webpack_public_path__ + "static/media/neilsons_logo.1c8a2e8e.svg";